import RefreshIcon from '@mui/icons-material/Refresh';
import type { VehicleFormState } from 'app-components/flux/vehicle/vehicleTypes';
import ConfirmationDialog from 'components/Dialogs/ConfirmationDialog';
import React from 'react';

type ErrorStepProps = {
  handleDialogClose: () => void;
  navigateTo: (patch: Partial<Pick<VehicleFormState, 'dialogStep' | 'userPath' | 'name'>>) => void;
};

export const ErrorStep = (props: ErrorStepProps) => {
  const { navigateTo, handleDialogClose } = props;

  return (
    <ConfirmationDialog
      title='Error while valuating'
      content="Choose Try again below to review your vehicle's information and re-submit."
      confirmLabel='Try again'
      confirmStartIcon={<RefreshIcon />}
      denyLabel='Cancel & close'
      onClose={(_event: React.SyntheticEvent, dEvent: string): boolean | void => {
        if (dEvent === 'CONFIRM') {
          navigateTo({ dialogStep: 'details' });
          return false;
        }
        if (dEvent === 'DENY') {
          handleDialogClose();
          return true;
        }
      }}
    />
  );
};
